import React, { useEffect, useState } from "react";
import { API_BASE } from "../utils/draftutils";

export default function VisualizzaInsiemi() {
  const [insiemi, setInsiemi] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/proposte/insiemi-chiusi`, { credentials: "include" });
        if (!res.ok) throw new Error("Errore nel caricamento");
        const data = await res.json();          // array flat di DTO
        // raggruppa per gruppo
        const byGroup = {};
        data.forEach(p => {
          byGroup[p.gruppo] ??= [];
          byGroup[p.gruppo].push(p);
        });
        setInsiemi(Object.values(byGroup));     // array di array
      } catch (e) {
        setErr(e.message);
      }
    })();
  }, []);
  
  return (
    <div className="container py-4">
      <h2 className="mb-4">PROPOSTE CHIUSE</h2>
      {err && <p className="text-danger">{err}</p>}
      <hr className="my-4" />

      {insiemi.length === 0 && !err && <p>Nessun insieme chiuso al momento.</p>}

      {/* un riquadro (card) per ogni insieme */}
      {insiemi.map((gruppo, idx) => (
        <div key={idx} className="card mb-4 shadow-sm">
          <div className="card-header bg-info-subtle">
            <strong>Insieme chiuso #{idx + 1}</strong>
          </div>

          <ul className="list-group list-group-flush">
            {gruppo.map(p => (
              <li key={p.id} className="list-group-item">
                <strong>{p.fruitoreNome}</strong> ({p.fruitoreMail}) offre{" "}
                {p.oreOfferte} h di <strong>{p.fogliaOfferta}</strong>{" "}
                in cambio di {p.oreRichieste} h di{" "}
                <strong>{p.fogliaRichiesta}</strong>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
